module.exports = __webpack_public_path__ + "static/media/integrations_workspace.5a148889.svg";